import { Controller } from 'stimulus'

export default class extends Controller {

  initialize() {
   window.bvi ||= new isvek.Bvi({ builtElements: true, reload: true, panelFixed: false })
  }
}
